import { Box, Divider, Grid, Stack } from "@mui/material";
import { ExpandableContainer } from "../Collapsible/ExpandableContainer";
import { CounterMetricCard } from "./CountMetricCard";
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { RefreshButton } from "../Button/RefreshButton";

import { useEffect } from "react";
import { updateAssetCountTotal } from "../../store/reducers/analytics/asset.metrics";
import {
  updateAlertCount,
  updateMaintenanceScheduleCountTotal,
} from "../../store/reducers/analytics/maintenance-schedule.metrics";
import { fetchDomainMetric } from "../../store/reducers/analytics/domain.metrics";
import { fetchUserCountTotal } from "../../store/reducers/analytics/user.metrics";

export const GeneralMetricsUI = () => {
  const { total: totalAssets } = useAppSelector((d) => d.assetMetrics);
  const {
    totalDistricts,
    totalDivision,
    totalFacilities,
    totalProgrammes,
    totalRegions,
    loading,
  } = useAppSelector((d) => d.domainMetrics);
  const totalUsers = useAppSelector((d) => d.userMetrics.total);

  const { total_upcoming_count, total_overdue_count } = useAppSelector(
    (d) => d.maintenanceSchedulesMetrics
  );

  const { total: totalSchedules } = useAppSelector(
    (d) => d.maintenanceSchedulesMetrics
  );
  const dispatch = useAppDispatch();

  const fetch = async () => {
    dispatch(updateAssetCountTotal());
    dispatch(updateMaintenanceScheduleCountTotal());
    dispatch(updateAlertCount());
    dispatch(fetchDomainMetric());
    dispatch(fetchUserCountTotal());
  };

  useEffect(() => {
    fetch();
  }, []);
  return (
    <ExpandableContainer label="General Analytics" initOpenState={true}>
      <Stack sx={{ width: "100%" }} spacing={1} mt={2}>
        <Stack width={"100%"} direction={"row"} justifyContent={"flex-end"}>
          <RefreshButton onclick={fetch} loading={false} />
        </Stack>
        <Divider />
        <Box width={"100%"}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
          >
            <Grid item xs={2} sm={6} md={6} lg={3}>
              <CounterMetricCard
                title="Total Assets"
                value={totalAssets?.toString()}
                type="assets"
              />
            </Grid>

            <Grid item xs={2} sm={6} md={6} lg={3}>
              <CounterMetricCard
                title="Total Maintenance Schedules"
                value={totalSchedules?.toString()}
                type="maintenance"
              />
            </Grid>
            <Grid item xs={2} sm={6} md={6} lg={3}>
              <CounterMetricCard
                title="Overdue maintenance schedules"
                value={total_overdue_count?.toString()}
                type="maintenance"
              />
            </Grid>
            <Grid item xs={2} sm={6} md={6} lg={3}>
              <CounterMetricCard
                title="Upcoming maintenance schedules"
                value={total_upcoming_count?.toString()}
                type="maintenance"
              />
            </Grid>

            <Grid item xs={2} sm={6} md={6} lg={3}>
              <CounterMetricCard
                title="Total Users"
                value={totalUsers?.toString()}
              />
            </Grid>

            <Grid item xs={2} sm={6} md={6} lg={3}>
              <CounterMetricCard
                title="Total Regions"
                value={totalRegions?.toString()}
              />
            </Grid>

            <Grid item xs={2} sm={6} md={6} lg={3}>
              <CounterMetricCard
                title="Total Districts"
                value={totalDistricts?.toString()}
              />
            </Grid>

            <Grid item xs={2} sm={6} md={6} lg={3}>
              <CounterMetricCard
                title="Total Divisions"
                value={totalDivision?.toString()}
              />
            </Grid>

            <Grid item xs={2} sm={6} md={6} lg={3}>
              <CounterMetricCard
                title="Total Facilities"
                value={totalFacilities?.toString()}
              />
            </Grid>
            <Grid item xs={2} sm={6} md={6} lg={3}>
              <CounterMetricCard
                title="Total Programmes"
                value={totalProgrammes?.toString()}
              />
            </Grid>
          </Grid>
        </Box>
      </Stack>
    </ExpandableContainer>
  );
};
